/* eslint-disable no-console */
/* eslint-disable max-len */
import _get from 'lodash/get.js';
import { log, LogLevels } from '../api/logApi';

export const APP_ACTION_ATC = 'Add To Cart';
export const APP_ACTION_ATC_BOPIS = 'Add To Cart BOPIS';
export const APP_ACTION_ATC_DFS = 'Add To Cart DeliverFromStore';
export const APP_ACTION_ATC_STH = 'Add To Cart DeliverFromStore';
export const APP_ACTION_ATC_FBT = 'Add To Cart Frequently Bought Together';
export const APP_ACTION_ATC_STS = 'Add To Cart ShipToStore';
export const APP_ACTION_ATC_SUGGESTION = 'Add To Cart Suggested Item';
export const APP_ACTION_PIP_LOAD = 'Pip Load';
export const APP_ACTION_SKU_MAP_CALL = 'SKU Map Call';
export const APP_ACTION_SKU_PRICING_CALL = 'SKU Pricing Call';
export const APP_ACTION_SURROUND_VISUALIZER = 'LP Surround Visualizer Loading';
export const APP_ACTION_ATB_FAIL = 'Add to Bundle Fail';
export const APP_ACTION_CREATE_CONFIG_FAIL = 'Create Configuration Fail';

export const API_ENDPOINT_CART = 'cartApi';
export const API_ENDPOINT_CHECK_NEARBY_STORES = 'checkNearbyStoresApi';
export const API_ENDPOINT_CONFIGURATION = 'configurationApi';
export const API_ENDPOINT_EDIT_CONFIGURATION = 'editConfigurationApi';
export const API_ENDPOINT_EXECUTE_RULES = 'executeRulesApi';
export const API_ENDPOINT_GALLERY = 'galleryApi';
export const API_ENDPOINT_GCC_PRODUCT_DETAILS = 'gccProductDetailsApi';
export const API_ENDPOINT_GET_FREQUENTLY_BT = 'frequentlyBoughtTogetherApi';
export const API_ENDPOINT_PRICE = 'priceApi';
export const API_ENDPOINT_SKUMAPPER = 'skuMapperApi';
export const API_ENDPOINT_SKU_PRICING = 'skuMapperPricing';
export const API_ENDPOINT_THD_PRODUCT_DETAILS = 'thdProductDetailsApi';
export const API_ENDPOINT_SHIPPING_OPTIONS = 'shippingOptionsv2Api';
export const API_ENDPOINT_ESTIMATE_DELIVERY_SO = 'estimateDeliverySpecialOrderApi';
export const API_ENDPOINT_CHOICE_SKU_AVAILABILITY = 'Check Choice And Sku Availability';
export const API_ENDPOINT_GET_QUICK_VIEW_PRICING = 'Get Quick View Pricing';
export const API_ENDPOINT_EARLIEST_DELIVERY_CHECK = 'earliestDeliveryCheckApi';
export const API_ENDPOINT_LINE_ITEM_PRICING = 'custom line Item Pricing';

export const CONTEXT_ATC_CHECK_STORES = 'add-to-cart-check-stores';
export const CONTEXT_ATC_BOPIS = 'add-to-cart-bopis';
export const CONTEXT_ATC_DFS = 'add-to-cart-deliverfromstore';
export const CONTEXT_ATC_STH = 'add-to-cart-shiptohome';
export const CONTEXT_ATC_FBT = 'add-to-cart-fbt';
export const CONTEXT_ATC_STS = 'add-to-cart-shiptostore';
export const CONTEXT_ATC_SUGGESTION = 'add-to-cart-suggested-item';
export const CONTEXT_SKU_MAP_NO_RESULT = 'sku-map-no-result';
export const CONTEXT_SKU_PRICING_NO_RESULT = 'sku-pricing-no-result';
export const CONTEXT_SURROUND_VISUALIZER = 'failed-surround-visualizer-load';
export const CONTEXT_ATB_CONFIG_FAIL = 'failed-create-configuration';
export const FAILED_PIP_LOAD = 'failed-pip-load';
export const SUCCESS_PIP_LOAD = 'success-pip-load';
export const CONTEXT_ATB_FAIL = 'add-to-bundle-fail';
export const API_ENDPOINT_DELETE_LINEITEM = 'deleteLineItemApi';
export const MPN_UNAVAILABLE = 'mpn-unavailable';

export const API_UPLOAD_IMAGE = 'uploadImageApi';

export const REMOVE_UPLOAD_IMAGE = 'removeImageApi';

export const REMOVE_LINE_ITEM_S3 = 'removeLineItemS3';

export const COPY_LOGO = 'createPurchasedLogoApi';

export const ADD_PREV_LOGO_TO_NEWLINEITEM_API = 'AddPrevLogoToNewLineItemApi';

export const CREATE_LIQUIDPIXEL_UPDATED_LOGO = 'updateLiquidPixelLogoToS3Api';

const recordPageAction = (actionName, actionObject) => {
  try {
    if (newrelic) {
      newrelic.addPageAction(actionName, actionObject);
    } else {
      log('Object newrelic not found.', LogLevels.Warn).catch((error) => {
        console.log(error);
      }); // eslint-disable-line no-console
    }
  } catch (error) {
    log(
      `Error calling newrelic addPageAction with actionName = '${actionName}'`,
      LogLevels.Error
    ).catch(() => {
      console.log(error);
    }); // eslint-disable-line no-console
  }
};

export const recordStormDoorAction = (appAction, description, context) => {
  recordPageAction('storm-door-action', {
    appAction,
    description,
    context,
  });
  return true;
};

export const quickViewError = (appAction, description, context) => {
  recordPageAction('quick-view-error', {
    appAction,
    description,
    context,
  });
  return true;
};

const API_ACTION_NAME = 'storm-door-api';

export const recordStormDoorApiFailure = (endPointName, status, url, params) => {
  recordPageAction(API_ACTION_NAME, {
    endPointName,
    status,
    url,
    params,
  });
};

export const recordStormDoorApiSuccess = (endPointName, status) => {
  recordPageAction(API_ACTION_NAME, {
    endPointName,
    status,
  });
};

export const recordApiResponse = (promise, apiEndPoint, url, params) =>
  promise
    .then((response) => {
      recordStormDoorApiSuccess(apiEndPoint, '200');
      return response;
    })
    .catch((error) => {
      recordStormDoorApiFailure(apiEndPoint, _get(error, 'response.status', 500), url, params);
      throw error;
    });

export const recordVizualizerFailure = (appAction, description, context) => {
  recordPageAction('ppe-visualizer-failure', {
    appAction,
    description,
    context,
  });
  return true;
};

const APP_ACTION_PPE_CREATE_DESIGN_FAILED = 'PPE - Add to cart - Create DESIGN Failed';
export const recordPpeCreateDesignFailure = (err, designId, containerId, storeNumber) => {
  recordPageAction(APP_ACTION_PPE_CREATE_DESIGN_FAILED, {
    err,
    designId,
    containerId,
    storeNumber,
  });
};

const APP_ACTION_PPE_ADD_TO_CART_CREATE_ITEM_ORDER_SUMMARY_SAGA_FAILED = 'PPE - Add to cart - Create Item - OrderSummarySaga Failed';
export const recordPpeAddToCartCreateItemOrderSummarySagaFailure = (err, designId, containerId) => {
  recordPageAction(APP_ACTION_PPE_ADD_TO_CART_CREATE_ITEM_ORDER_SUMMARY_SAGA_FAILED, {
    err, designId, containerId,
  });
};

const APP_ACTION_PPE_ADD_TO_CART_CREATE_CONFIGURATION_ORDER_SUMMARY_SAGA_FAILED = 'PPE - Add to cart - Create Configuration - OrderSummarySaga Failed';
export const recordPpeAddToCartCreateConfigurationOrderSummarySagaFailure = (err, designId, newItem, orderSummaryItems) => {
  recordPageAction(APP_ACTION_PPE_ADD_TO_CART_CREATE_CONFIGURATION_ORDER_SUMMARY_SAGA_FAILED, {
    err, designId, newItem, orderSummaryItems,
  });
};

const APP_ACTION_PPE_START_REMOVE_FROM_BUNDLE_ORDER_SUMMARY_SAGA_FAILED = 'PPE - Start Remove From Bundle - OrderSummarySaga Failed';
export const recordPpeStartRemoveFromBundleOrderSummarySagaFailure = (error, id, orderSummaryItems) => {
  recordPageAction(APP_ACTION_PPE_START_REMOVE_FROM_BUNDLE_ORDER_SUMMARY_SAGA_FAILED, {
    error, id, orderSummaryItems,
  });
};

const APP_ACTION_PPE_MERGE_BUNDLE_ORDER_SUMMARY_SAGA_FAILED = 'PPE - Merge Bundle - OrderSummarySaga Failed';
export const recordPpeMergeBundleOrderSummarySagaFailure = (error, summaryItems, id, userId) => {
  recordPageAction(APP_ACTION_PPE_MERGE_BUNDLE_ORDER_SUMMARY_SAGA_FAILED, {
    error, summaryItems, id, userId,
  });
};

const APP_ACTION_PPE_ADD_ITEM_TO_BUNDLE_START_SAGA_FAILED = 'PPE - Add Item To Bundle Start - OrderSummarySaga Failed';
export const recordPpeAddItemToBundleStartSagaFailure = (error, payload, uploadImages, partnerProductId) => {
  recordPageAction(APP_ACTION_PPE_ADD_ITEM_TO_BUNDLE_START_SAGA_FAILED, {
    error, payload, uploadImages, partnerProductId,
  });
};

export const APP_ACTION_CREATE_PURCHASED_LOGO_FAILED = 'PPE - Create Purchased Logo - OrderSummarySaga Failed';
export const recordPpeCreatePurchasedLogoFailure = (error, orderSummaryItems) => {
  recordPageAction(APP_ACTION_CREATE_PURCHASED_LOGO_FAILED, {
    error, orderSummaryItems,
  });
};

const APP_ACTION_CREATE_ORDER_LOGO_FAILED = 'PPE - Create Order Logo - OrderSummarySaga Failed';
export const recordPpeCreateOrderLogoFailure = (error, currentSelectedItem) => {
  recordPageAction(APP_ACTION_CREATE_ORDER_LOGO_FAILED, {
    error, currentSelectedItem,
  });
};

const APP_ACTION_CREATE_PREVIOUS_LOGO_TO_NEW_LINE_ITEM_FAILED = 'PPE - Copy Previous Logo To New Line Item - OrderSummarySaga Failed';
export const recordPpeCopyPreviousLogoToNewLineItemFailure = (error, currentSelectedItem, previousSelections) => {
  recordPageAction(APP_ACTION_CREATE_PREVIOUS_LOGO_TO_NEW_LINE_ITEM_FAILED, {
    error, currentSelectedItem, previousSelections,
  });
};

const APP_ACTION_UPDATE_LP_LOGO_TO_S3_FAILED = 'PPE - Update Liquid Pixel Logo to S3 - OrderSummarySaga Failed';
export const recordPpeUpdateLiquidPixelLogoToS3Failure = (error, orderSummaryItems) => {
  recordPageAction(APP_ACTION_UPDATE_LP_LOGO_TO_S3_FAILED, {
    error, orderSummaryItems,
  });
};

const APP_ACTION_PPE_CREATE_ITEM_FAILED = 'PPE - Add to cart - Create ITEM Failed';
export const recordPpeCreateItemFailure = (err, designId, containerId, orderSummaryItems) => {
  recordPageAction(APP_ACTION_PPE_CREATE_ITEM_FAILED, {
    err,
    designId,
    containerId,
    orderSummaryItems,
  });
};

const APP_ACTION_PPE_CREATE_CONFIGURATION_FAILED =
  'PPE - Add to cart - Create CONFIGURATION Failed';
export const recordPpeCreateConfigurationFailure = (
  err,
  designId,
  containerId,
  orderSummaryItems
) => {
  recordPageAction(APP_ACTION_PPE_CREATE_CONFIGURATION_FAILED, {
    err,
    designId,
    containerId,
    orderSummaryItems,
  });
};

const APP_ACTION_PPE_CREATE_ITEM_PRODUCT_FAILED = 'PPE - Add to cart - Create ITEM PRODUCT Failed';
export const recordPpeCreateItemProductFailure = (
  err,
  orderSummaryItems,
  localStoreId,
  zipCode,
  customData
) => {
  recordPageAction(APP_ACTION_PPE_CREATE_ITEM_PRODUCT_FAILED, {
    err,
    orderSummaryItems,
    localStoreId,
    zipCode,
    customData,
  });
};
